import React from 'react';
import { ClickAwayListener } from '@mui/material';
import { TooltipButton, Tooltip } from 'spw-shared/globalComponents';
import ShowTooltipIcon from 'spw-static/images/tooltip-icon.svg';
import {
  SubtotalTooltipTitle,
  SubtotalTooltipText,
  SubtotalTooltipContainer,
} from './styles';

const tooltip = (
  <SubtotalTooltipContainer>
    <SubtotalTooltipTitle>Target Ratio and Qty Tip</SubtotalTooltipTitle>
    <div>
      <SubtotalTooltipText>
        Target Ratio and Qty values have a maximum value constraint applied for
        more accurate calculations. If you enter a Target Ratio or Qty value
        larger than your Total Work Seats, your input will revert down to the
        maximum Total Work Seats available in your scenario.
      </SubtotalTooltipText>
    </div>
  </SubtotalTooltipContainer>
);

// currently hidden, rm display: none from styles below to show

export const TargetRatioTooltip = () => {
  const [showTooltip, setShowTooltip] = React.useState(false);
  return (
    <ClickAwayListener onClickAway={() => setShowTooltip(false)}>
      <Tooltip
        onClose={() => setShowTooltip(false)}
        title={tooltip}
        placement="bottom-end"
        disableHoverListener
        disableFocusListener
        disableTouchListener
        open={showTooltip}
        PopperProps={{
          popperOptions: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  enabled: true,
                  offset: [16, 0],
                },
              },
            ],
          },
        }}
      >
        <TooltipButton
          theme={{ show: showTooltip }}
          onClick={() => setShowTooltip(!showTooltip)}
          style={{ display: 'none' }}
        >
          <img alt="tooltip-icon" src={ShowTooltipIcon} />
        </TooltipButton>
      </Tooltip>
    </ClickAwayListener>
  );
};
